import { resolveClient } from './supabase';
import type { Metric } from '@lingaai/types';
import type { SupabaseClient } from '@supabase/supabase-js';

export async function getMetrics(submissionId: string, client?: SupabaseClient): Promise<Metric[]> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('metrics').select('*').eq('submission_id', submissionId);

  if (error) throw error;
  return data as Metric[];
}

export async function createMetric(data: Omit<Metric, 'id' | 'created_at' | 'updated_at'>, client?: SupabaseClient): Promise<Metric> {
  const supabase = resolveClient(client);

  const { data: metric, error } = await supabase.from('metrics').insert(data).select().single();

  if (error) throw error;
  return metric as Metric;
}

export async function updateMetric(metricId: string, updates: Partial<Metric>, client?: SupabaseClient): Promise<Metric> {
  const supabase = resolveClient(client);

  const { data, error } = await supabase.from('metrics').update(updates).eq('id', metricId).select().single();

  if (error) throw error;
  return data as Metric;
}

/**
 * Get count of metrics, optionally filtered by portfolio company.
 */
export async function getMetricsCount(portfolioCompanyId?: string, client?: SupabaseClient): Promise<number> {
  const supabase = resolveClient(client);

  let query = supabase.from('metrics').select('id', { count: 'exact', head: true });

  if (portfolioCompanyId) {
    query = query.eq('portfolio_company_id', portfolioCompanyId);
  }

  const { count, error } = await query;
  if (error) throw error;
  return count || 0;
}
